document.addEventListener("DOMContentLoaded", function () {
  customAccordion();
});

function customAccordion() {
  const wrappers = document.querySelectorAll('.content-wrapper');
  if (!wrappers.length) return;

  const COLLAPSED_HEIGHT = 90;

  wrappers.forEach(wrapper => {
    const content = wrapper.querySelector('.content-text');
    const arrow = wrapper.querySelector('.arrow svg');

    if (!content || !arrow) return;

    const fullHeight = content.scrollHeight;

    // If content is short → no accordion needed
    if (fullHeight <= COLLAPSED_HEIGHT) {
      content.style.maxHeight = "none";
      arrow.style.display = "none";
      wrapper.classList.add('no-accordion');
      return;
    }

    // Accordion needed
    content.style.maxHeight = COLLAPSED_HEIGHT + "px";
    arrow.style.display = "block";

    wrapper.addEventListener("click", () => {

      wrappers.forEach(w => {
        if (w !== wrapper && !w.classList.contains('no-accordion')) {
          const c = w.querySelector('.content-text');
          const a = w.querySelector('.arrow svg');
          if (c && a) {
            c.style.maxHeight = COLLAPSED_HEIGHT + "px";
            a.classList.remove("rotate");
          }
        }
      });

      if (content.style.maxHeight === COLLAPSED_HEIGHT + "px") {
        content.style.maxHeight = fullHeight + "px";
        arrow.classList.add("rotate");
      } else {
        content.style.maxHeight = COLLAPSED_HEIGHT + "px";
        arrow.classList.remove("rotate");
      }
    });
  });
}